import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderSevenDays from "../../../../src/content/seven-days-in-the-holy-land/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderSevenDays,
  React
};